export default class WordList {
  static loaders = {
    4: () => import(/* webpackChunkName: "wordlist-4" */ "../../../wordlists/wordlist-4.json"),
    5: () => import(/* webpackChunkName: "wordlist-5" */ "../../../wordlists/wordlist-5.json"),
    6: () => import(/* webpackChunkName: "wordlist-6" */ "../../../wordlists/wordlist-6.json"),
  }

  static hasWordlist(length) {
    return !!WordList.loaders[length]
  }

  constructor(length) {
    this.length = length

    if (!WordList.loaders[length]) {
      console.error("No wordlist for length", length)
      this.length = 5
    }

    this.list = null
    this.ready = this.load()
  }

  async load() {
    const module = await WordList.loaders[this.length]()
    this.list = module.default
    return this
  }

  // Binary search against the sorted wordlist
  includes(word) {
    const target = word.toLowerCase()
    if (!this.list) return false
    return (this.list['taboo'].includes(target) || this.list['remaining'].includes(target))
  }

  selectRandomWord() {
    return this.list['taboo'][Math.floor(Math.random() * this.list['taboo'].length)].toUpperCase()
  }
}
